/* @jsxImportSource react */

import type { AriaAttributes } from 'react';
import type { VariantProps } from 'class-variance-authority';
import { NewEnergyEfficiencyFlagIcon } from './NewEnergyEfficiencyFlag.Icon';
import { icon } from '../EnergyEfficiencyFlag.variants';
import { colorsForEnergyEfficiency } from '../colorsForEnergyEfficiency';
import { flag } from './NewEnergyEfficiencyFlag.variants';

export type NewEnergyEfficiencyFlagProps = {
  efficiencyClass: keyof typeof colorsForEnergyEfficiency;
  size?: VariantProps<typeof flag>['size'];
} & AriaAttributes;

export const NewEnergyEfficiencyFlag = ({
  efficiencyClass,
  size = 'normal',
  'aria-label': ariaLabel,
  ...props
}: NewEnergyEfficiencyFlagProps) => (
  <span
    className="font-family-efficiency-label bg-color-transparent text-decoration-none relative inline-flex items-center"
    {...(ariaLabel && { 'aria-label': ariaLabel })}
    {...props}
  >
    <NewEnergyEfficiencyFlagIcon
      className={icon({
        size,
        color: colorsForEnergyEfficiency[efficiencyClass],
      })}
    />
    <span className={flag({ size })}>{efficiencyClass}</span>
  </span>
);
